import {initDetailsAccordion} from '../modules/details-accordion.js';

initDetailsAccordion({
  item: '.faq__item',
  summary: '.faq__question',
  content: '.faq__answer-wrap',
});
